import React, { useState } from "react";
import { useFormik } from "formik";
import { Button, Card, CardContent, CircularProgress } from "@mui/material";
import MessageComp from "../../components/SharedComp/MessageComp";
import useAuth from "../../Utils/useAuth";
import { ApiLoginMsgHandler } from "../../Utils/Constants.";
import * as Yup from "yup";
import PopOverInput from "../../components/SharedComp/PopOverInput";
import InputFormField from "../../components/SharedComp/InputFormField";

const LoginPage = () => {
  /**
//    * @component  LoginPage
//    * @description login page to validate authenticate user
//    * @returns Login Page UI
//    */

  const { login } = useAuth();
  const [showMsgComp, setShowMsgComp] = useState(false);
  const [msgContent, setMsgContent] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  /**
   *
   * @param {*login form submitted values} values
   */
  const onSubmit = async (values) => {
    // one login request at a time (Enter held / double click)
    if (isLoading) return;
    setIsLoading(true);
    setShowMsgComp(false);
    let formData = {
      EmailAddress: values.EmailAddress,
      Password: values.Password,
      // "nA/t7ZjbF97/KQ=="
    };

    await login(formData).then((response) => {
      if (response) {
        setIsLoading(false);
        setShowMsgComp(true);
        setMsgContent(ApiLoginMsgHandler(response));
      }
    });
  };

  const { handleSubmit, getFieldProps, setValues, touched, errors } = useFormik(
    {
      initialValues: {
        EmailAddress: "",
        Password: "",
      },
      validationSchema: Yup.object().shape({
        EmailAddress: Yup.string()
          .email("Invalid email address")
          .required("Email is Required"),
        Password: Yup.string()
          .min(8, "Must be more than 8 characters")
          .required("Password is Required"),
      }),
      onSubmit(values) {
        onSubmit(values);
        setValues({
          ...values,
        });
      },
    }
  );

  return (
    <div>
      <MessageComp
        msg={msgContent}
        id="login-success"
        show={showMsgComp}
        loginPage={true}
      />
      <div className="loginBox">
        <Card className="loginCard">
          <CardContent>
            <div className="contentLogo">
              <img src="Images/logo.png" alt="logo" />
              <span>ADS</span>
            </div>
            <div className="boxTitle">LOGIN</div>
            <form className="baseForm" onSubmit={handleSubmit} noValidate>
              <PopOverInput
                fieldError={errors}
                fieldName="EmailAddress"
                fieldLabel="Email"
                touched={touched}
                fieldRequired={true}
              >
                <InputFormField
                  {...getFieldProps("EmailAddress")}
                  fieldType="email"
                  fieldName="EmailAddress"
                  errors={errors}
                  touched={touched}
                />
              </PopOverInput>
              <div className="marginBottom" />
              <PopOverInput
                fieldError={errors}
                fieldName="Password"
                fieldLabel="Password"
                touched={touched}
                fieldRequired={true}
              >
                <InputFormField
                  {...getFieldProps("Password")}
                  fieldType="password"
                  fieldName="Password"
                  errors={errors}
                  touched={touched}
                />
              </PopOverInput>
              <div className="marginBottom" />
              <div className="loginBtn">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  className="btn btn-primary btn-block"
                  disabled={isLoading}
                >
                  {isLoading && (
                    <CircularProgress
                      size={15}
                      color="info"
                      className="circularProgressLoader"
                    />
                  )}
                  &nbsp; Log in
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;
